import { Params } from '@angular/router';
import { RouterReducerState } from '@ngrx/router-store';
import { UserInformation } from './user-information/user-information';
import { AuthState } from '@rci/self-serve-fido/state/auth/auth.state';

export interface SelfServeAppState {
  appId: string;
  authState: AuthState;
  router: RouterReducerState<IRouterStateUrl>;
  userInformation: UserInformation;
}

export interface IRouterStateUrl {
  url: string;
  queryParams: Params;
  params: Params;
}

export enum UserType {
  consumer = 'consumer',
  agent = 'agent',
}
